import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import DataTableActions from "../../components/datatable/data-table-actions";
import DataTableBase from "../../components/datatable/data-table-base";
import {useNavigate} from "react-router-dom";
import {AppRoutes} from "../../utils/constants";
import {useRepresentativeService} from "../../services/representative-service";
import AddEditRepresentativeModal from "./add-edit-representative-modal";


export default function RepresentativesList () {
  let representativeService = useRepresentativeService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const addEditModal = useRef();
  const navigate = useNavigate();

  useEffect(()=>{
    representativeService.getList()
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }, []);

  const onAddEditAction = (row=null, e=null)=>{
    addEditModal.current.openModal(row);
  };

  const onAddEditCallbackAction = (item=null)=>{
    setRows(HelperService.addOrReplaceItemInList(rows,item));
  };

  const onDelAction = (item, e=null)=>{
    if (true===confirm('Naozaj odstrániť záznam?')){
      representativeService.delModel(item.id)
        .then(()=>{
          setRows(HelperService.removeItemFromList(rows,item));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const columns = [{
    name: 'Meno',
    selector: row => row.name,
    sortable: true,
  },{
    name: 'Rodné číslo',
    selector: row => row.birth_number,
    sortable: true,
  },{
    cell: row => <DataTableActions row={row} actions={[
      {title: 'Upraviť', icon: <span className="mdi mdi-book-edit-outline"></span>, action: onAddEditAction, className: 'hover-text-primary'},
      {title: 'Zmazať', icon: <span className="mdi mdi-trash-can-outline"></span>, action: onDelAction, className: 'hover-text-danger'},
    ]} />,
    right: true,
    allowOverflow: true,
    button: false,
  }];

  return (
    <>
      <AddEditRepresentativeModal ref={addEditModal} onSuccess={onAddEditCallbackAction} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Delegáti</PageTitle>

          <button className="btn btn-primary mb-2" onClick={(e)=>onAddEditAction(null, e)}><span className="mdi mdi-plus"></span> Pridať</button>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                 <DataTableBase
                    progressPending={!loaded}
                    columns={columns}
                    data={rows}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

RepresentativesList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

RepresentativesList.getSEO = function getSEO() {
  return {
    title: "Delegáti",
  }
}
